import { commitMutation, graphql } from 'react-relay/legacy';
import { MAX_CART_ITEMS } from '../../actions/cartActions';

const mutation = graphql`
    mutation addCartItemMutation($input: ModifyPortfolioItemsInput!) {
        modifyPortfolioItems(input: $input) {
            portfolio {
                items {
                    totalResults
                }
            }
        }
    }
`;

export function addCartItemMutation({ environment, items, userId, onCompleted, onError }) {
    // `filter` array to ensure it doesn't contain falsy values
    items = (items || []).filter(Boolean);

    if (!items || !items.length) {
        return null;
    }

    items = items.slice(-MAX_CART_ITEMS).map(item => ({
        itemId: item.id,
        skuId: item.skuId,
        quantity: item.quantity,
    }));

    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                action: 'ADD',
                portfolioType: 'CART',
                items,
                userId,
            },
        },
        onCompleted,
        onError,
    });
}
